/* eslint-disable */
import React from 'react';

const StarIconFan5 = ({ className, color = 'currentcolor' }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 400 400"
			className={className}>
			<g fill={color}>
				<path d="M210.08,391.46c-6.81,0-13.63,0-20.44,0c-0.41-0.08-0.82-0.2-1.23-0.22c-6.6-0.34-13.15-1.09-19.66-2.19
		c-38.21-6.47-71.45-23.04-99.7-49.5c-18.78-17.59-33.35-38.23-43.79-61.76c-8.18-18.43-13.3-37.69-15.28-57.77
		c-0.3-3.02-0.56-6.04-0.84-9.06c0-6.81,0-13.63,0-20.44c0.08-0.46,0.2-0.92,0.23-1.39c0.35-6.49,1.08-12.94,2.16-19.34
		c6.42-38.11,22.88-71.28,49.2-99.52c17.5-18.78,38.06-33.38,61.51-43.88c18.61-8.33,38.05-13.52,58.35-15.52
		c3.02-0.3,6.04-0.56,9.06-0.84c6.81,0,13.63,0,20.44,0c0.41,0.08,0.82,0.2,1.23,0.22c7.28,0.37,14.5,1.25,21.67,2.54
		c37.3,6.73,69.8,23.08,97.47,48.93c18.72,17.49,33.29,38.01,43.76,61.4c8.33,18.61,13.52,38.06,15.53,58.35
		c0.3,3.02,0.56,6.04,0.84,9.06c0,6.81,0,13.63,0,20.44c-0.08,0.46-0.2,0.92-0.23,1.39c-0.35,6.54-1.09,13.04-2.19,19.5
		c-6.57,38.71-23.45,72.29-50.48,100.73c-17.35,18.26-37.62,32.46-60.64,42.7c-18.48,8.22-37.78,13.35-57.91,15.34
		C216.11,390.91,213.09,391.17,210.08,391.46z M287.34,319.56c-0.06-0.35-0.12-0.66-0.17-0.97c-0.83-4.85-1.65-9.71-2.49-14.56
		c-4.48-25.96-8.95-51.93-13.47-77.89c-0.34-1.95,0.13-3.48,1.53-4.84c6.87-6.69,13.72-13.4,20.58-20.1
		c15.71-15.34,31.41-30.68,47.11-46.03c0.33-0.32,0.91-0.64,0.81-1.09c-0.14-0.6-0.86-0.48-1.35-0.55
		c-3.99-0.6-7.98-1.16-11.97-1.73c-26.54-3.83-53.08-7.71-79.63-11.44c-3.32-0.47-5.35-1.86-6.82-4.87
		c-10.39-21.28-20.9-42.5-31.38-63.74c-3.15-6.39-6.32-12.77-9.5-19.15c-0.2-0.4-0.34-0.99-0.89-1c-0.56-0.01-0.69,0.58-0.89,0.98
		c-1.06,2.11-2.08,4.23-3.13,6.34c-12.76,25.84-25.55,51.66-38.26,77.53c-1.15,2.34-2.77,3.4-5.29,3.76
		c-22.77,3.23-45.52,6.53-68.28,9.82c-7.98,1.15-15.96,2.34-23.94,3.53c-0.5,0.07-1.25-0.02-1.44,0.44
		c-0.26,0.64,0.53,0.93,0.91,1.3c2.09,2.06,4.22,4.07,6.32,6.13c20.23,19.79,40.44,39.59,60.68,59.35c1.73,1.69,2.35,3.48,1.93,5.92
		c-5.29,30.61-10.51,61.23-15.74,91.85c-0.09,0.54-0.52,1.23,0.03,1.62c0.52,0.37,1.08-0.2,1.57-0.46
		c7.11-3.7,14.22-7.41,21.32-11.14c20.32-10.66,40.65-21.32,60.94-32.03c2.18-1.15,4.07-1.39,6.34-0.14
		c6.01,3.3,12.13,6.42,18.21,9.6c17.97,9.4,35.94,18.79,53.91,28.18c3.67,1.92,7.34,3.82,11.03,5.71
		C286.45,320.18,287.19,320.84,287.34,319.56z"/>
			</g>
		</svg>

	)
}

export default StarIconFan5;